import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HelpCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"help_center"}/>
}
